module.exports = __webpack_public_path__ + "assets/img/per-7ec7356f.png";